import type { HistoryEntry } from "./types";

// An order's history (order_history) as the screens show it. Pure, so it is tested without a browser.

/** The email, exception or document an entry is about, to open from it; none for the rest. */
export function historyLink(e: HistoryEntry): { href: string; text: string } | null {
  if (e.draftId) return { href: `/draft/${e.draftId}`, text: "Open the email" };
  if (e.exceptionId) return { href: `/exception/${e.exceptionId}`, text: "Open the exception" };
  if (e.documentId) return { href: `/document/${e.documentId}`, text: "Open the document" };
  return null;
}

/** The entries about one vendor PO (its vendor PO screen); the order's own entries stay on the order screen. */
export function forVendorPo(history: HistoryEntry[], vendorPo: string): HistoryEntry[] {
  return history.filter((e) => e.vendorPo === vendorPo);
}

/** What happened, in a word or two, for the entry's pill (the sentence says the rest). */
const EVENT_LABEL: Record<string, string> = {
  ORDER_RECORDED: "order recorded", DOCUMENT_LINKED: "document", VENDOR_PO_DRAFTED: "PO drafted",
  VENDOR_PO_APPROVE: "approved", VENDOR_PO_WITHDRAW_APPROVAL: "approval withdrawn", VENDOR_PO_PREPARE_EMAIL: "email asked for",
  EMAIL_PREPARED: "email prepared", EMAIL_DISCARDED: "email discarded", EMAIL_SENT: "email sent", VENDOR_PO_SENT: "PO sent",
  CHANGE_REQUESTED: "change asked", CHANGE_APPLIED: "change accepted", CHANGE_REJECTED: "change rejected", CHANGED: "changed",
  SHIPPED: "shipped", DELIVERED: "delivered", EXCEPTION_OPENED: "exception", EXCEPTION_ACKNOWLEDGED: "acknowledged",
  EXCEPTION_NOTE: "note", EXCEPTION_RESOLVED: "resolved", EXCEPTION_DISMISSED: "dismissed", EXCEPTION_REOPENED: "reopened",
};

export function eventLabel(event: string): string {
  return EVENT_LABEL[event] ?? event.toLowerCase().replace(/_/g, " ");
}

/** How the event reads at a glance: good for what moved forward, soon for steps back and problems to look at. */
export function eventTone(event: string): "late" | "soon" | "good" | "neutral" {
  if (/^EXCEPTION_OPENED$|_REOPENED$|_REJECTED$|DISCARDED$|WITHDRAW/.test(event)) return "soon";
  if (/SENT$|APPROVE$|APPLIED$|RESOLVED$|SHIPPED$|DELIVERED$/.test(event)) return "good";
  return "neutral";
}
